// extracted by mini-css-extract-plugin
module.exports = {"colorPrimary":"#2497ed","colorSecondary":"#eaf5fe","ChipListComponent":"ChipListComponent_ChipListComponent__cbVK0","label":"ChipListComponent_label__8zXLy"};